import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider, useLang, setHead } from "@/i18n/translations";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Events from "@/pages/Events";
import Booking from "@/pages/Booking";
import Shop from "@/pages/Shop";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  const { lang } = useLang();
  useEffect(() => { setHead(lang, location.pathname); }, [lang, location.pathname]);
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  // Google OAuth returns to /admin/callback#session_id=... — handle before anything else
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/services" element={<Layout><Services /></Layout>} />
      <Route path="/artistes" element={<Layout><Artists /></Layout>} />
      <Route path="/artistes/:slug" element={<Layout><ArtistDetail /></Layout>} />
      <Route path="/evenements" element={<Layout><Events /></Layout>} />
      <Route path="/booking" element={<Layout><Booking /></Layout>} />
      <Route path="/boutique" element={<Layout><Shop /></Layout>} />
      <Route path="/a-propos" element={<Layout><About /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
      <Route path="/payment/cancel" element={<Layout><PaymentCancel /></Layout>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/callback" element={<AuthCallback />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="bottom-right" theme="dark" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
